import React, { useRef } from 'react'
import PlayersTable from './players-table'
import AddPlayer from './add-player'

export default function GameDetails(props) {
  const { game, playerReservations, isLoading } = props
  const copyPhonesRef = useRef(null)
  const copyPlyersRef = useRef(null)
  const isGameFull = game.number_of_players >= game.max_number_of_players
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency?.toUpperCase()})`
  const gameBalance = playerReservations.reduce((balance, pr) => balance + parseFloat(pr.balance), 0).toFixed(2)

  const gameName = () => {
    return <blockquote className='blockquote'>
      <p>{game.displayed_name}</p>
      <footer>
        {game.full_time}&nbsp;
        <span className='fa fa-pencil'></span>
      </footer>
      
      <footer>
        {game.numbered_field_name}&nbsp;
        {
          game.field_name != game.numbered_field_name && 
          <span className='field-title-subname'>({game.field_name})</span>
        }
      </footer>
    </blockquote>
  }

  const playerPhones = (separator) => {
    let phones = []
    playerReservations.map(pr => {
      if (!pr.player_fake) phones.push(pr.player_phone)
    })
    return phones.join(separator)
  }

  const playersList = () => {
    let rows = []
    const nonFakePrs = playerReservations.filter(pr => !pr.player_fake)
    const startPrs = nonFakePrs.filter(pr => !pr.player_phone.match(/(222)/))
    const endPrs = nonFakePrs.filter(pr => pr.player_phone.match(/(222)/))
    startPrs.concat(endPrs).map(pr => {
      rows.push(pr.player_copy_name)
      _.times(pr.guests_number).map(i => rows.push(pr.player_copy_name + ` + Guest ${i + 1}`))
    })
    const indexedRows = rows.map((r, i) => `${i+1}. ` + r)
    return [`*${game.humanized_time}*`].concat(indexedRows).join("\n")
  }

  const copyToClipboard = (ref, text) => {
    navigator.clipboard.writeText(text)
    ref.current.blur()
  }

  return <div>
    { isLoading && <div className='animated-spinner'></div> }
    <div className='row'>
      <div className='col-md-6'>
        <a className='clickable edit-opengame-link' onClick={() => props.onEdit({type: 'edit', id: game.id})}>{gameName()}</a>
      </div>

      <div className='col-md-3'>
        <div className='panel panel-info'>
          <div className='panel-heading'>{`Expected Revenue${currencyName}:`}</div>
          <div className='panel-body cost-edit-form-wrapper'>
            <span className='total-reservation-cost'>$ {parseFloat(game.expected_revenue).toFixed(2)}</span>
          </div>
        </div>
      </div>

      <div className='col-md-3'>
        <div className='panel panel-success'>
          <div className='panel-heading'>{`Current Balance${currencyName}:`}</div>
          <div className='panel-body current-reservation-balance'>$ {gameBalance}</div>
        </div>
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-6 text-left d-inline'>
        <a 
          className='btn btn-default btn-lg fa fa-clone' 
          onClick={() => props.onDuplicate(game.id)}
          title='Duplicate game'
        >
        </a>
        <a 
          className='btn btn-default btn-lg btn-announcements' 
          onClick={props.onAnnouncements}
          title='Game Announcements'
        >
        </a>
        <a 
          className='btn btn-default btn-lg btn-add-fake' 
          onClick={props.onAddFake}
          title='Add fake player'
        >
        </a>
      </div>
      <div className='col-xs-6 text-right d-inline modal-controls'>
        <button 
          className='btn btn-default copy-btn' 
          ref={copyPhonesRef} 
          onClick={() => copyToClipboard(copyPhonesRef, playerPhones(' '))}
        >
          <span className='fa fa-clipboard' title='Copy all players phone number without commas'></span>
        </button>
        <button
          className='btn btn-default copy-btn'
          ref={copyPhonesRef}
          onClick={() => copyToClipboard(copyPhonesRef, playerPhones(', '))}
        >
          <img title='Copy all players phone number with commas' src='/images/players/comma.svg' />
        </button>
        <button 
          className='btn btn-default copy-btn' 
          ref={copyPlyersRef} 
          onClick={() => copyToClipboard(copyPlyersRef, playersList())}
        >
          <img src='/images/copy-players.png' title='Copy Player List'/>
        </button>
        <a className='btn btn-info clickable' onClick={() => !isLoading && props.onProcessAll()}>Process All</a>
        <a className='btn btn-info clickable' onClick={() => !isLoading && props.onCaptureAll()}>Capture All</a>
      </div>
    </div>

    <div className='row'>
      <div className='col-xs-12 player-reservations-table'>
        <div className='open-game-players-count'>{game.number_of_players}/{game.max_number_of_players}</div>
        <div id='players-list'>
          <PlayersTable 
            game={game}
            playerReservations={playerReservations}
            onUpdatePR={props.onUpdatePR}
            onEditCost={props.onEditCost}
            onChangeGuests={props.onChangeGuests}
            onCopyPhone={(phone) => navigator.clipboard.writeText(phone)}
            onRemovePlayer={props.onRemovePlayer}
            onShowPlayer={props.onShowPlayer}
            onShowPayment={props.onShowPayment}
          />
        </div>
      </div>
    </div>

    { !isGameFull && <AddPlayer gameId={game.id} onError={props.showAlert} onGameUpdated={props.roasterChanged} /> }
  </div>
}
